import type { IResponse } from '@/features/api/extranet'
import { ensureSuccessStatusCode, useFetch } from '@/features/fetch'

export function useFavorisApi<TData>(key: string) {
  async function saveFavoris(data: TData, init?: RequestInit) {
    // Recharger
    let dic = await loadFavorisInt(init)
    if (!dic) dic = {}
    dic[key] = data

    // Re-stocker
    const request: RequestInit = {
      ...init,
      method: 'PUT',
      body: JSON.stringify(dic),
    }

    // Stocke la demande
    const fetch = useFetch('extranet')
    const response = await fetch(`/favoris`, request)
    ensureSuccessStatusCode(response)
  }

  async function loadFavorisInt(init?: RequestInit) {
    if (!init) init = { sablier: true, dialogMode: 'retry' }

    // Stocke la demande
    const fetch = useFetch('extranet')
    const response = await fetch(`/favoris`, init)
    if (response.status === 204) return null

    ensureSuccessStatusCode(response)
    const result = (await response.json()) as IResponse<Record<string, any>>
    return result.data
  }

  async function loadFavoris(init?: RequestInit) {
    const dic = await loadFavorisInt(init)
    return dic?.[key]
  }

  return {
    saveFavoris,
    loadFavoris,
  }
}
